import { render } from "./DocumentListComponent.vue?vue&type=template&id=08512d68&scoped=true"
import script from "./DocumentListComponent.vue?vue&type=script&lang=js"
export * from "./DocumentListComponent.vue?vue&type=script&lang=js"

import "./DocumentListComponent.vue?vue&type=style&index=0&id=08512d68&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08512d68"]])

export default __exports__